import {useEffect, useState} from "react";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import '../../../static/css/pages/consult/consult.css';
import {CheckIcon} from "../../../components/icons/material-icons";
import {ShowSnackbar} from "../../../components/template/snackbar";

interface profileQuestionInterface {
    id: number,
    title: string,
    options: string[],
    type: 'text' | 'check' | 'radio',
    answer: string,
    error: boolean,
}

export const ParentsConsultProfileFormComponent = (props: { onDone: () => void }) => {
    const [questions, setQuestions] = useState<profileQuestionInterface[]>([]);
    const fetchData = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/consult/profile/questions',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: {
                    id: number,
                    title: string,
                    options: string,
                    type: 'text' | 'check' | 'radio',
                    sort: number,
                }[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                let lst: profileQuestionInterface[] = [];
                if (d.list !== null) {
                    const sorted = d.list.sort((a, b) => Number(a.sort) - Number(b.sort));
                    sorted.forEach(e => {
                        let options = [] as string[];
                        if (e.options !== '')
                            options = JSON.parse(e.options);
                        lst.push({
                            id: e.id,
                            title: e.title,
                            answer: '',
                            error: false,
                            options: options,
                            type: e.type,
                        });
                    });
                }
                setQuestions(lst);
            },
            () => {
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        fetchData();
    }, []);
    const saveForm = () => {
        let final:any[] = [];
        const _questions = [...questions];
        let stop = false;
        _questions.forEach(q => {
            if (q.answer.trim() === '') {
                q.error = true;
                stop = true;
            }
            final.push({
               id:q.id,
               answer:q.answer,
               type:q.type,
            });
        });
        if (stop) {
            setQuestions(_questions);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/consult/profile/save',
            {
                answers:JSON.stringify(final),
            },
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                props.onDone();
                ShowSnackbar(
                    'فرم مشاوره شما ذخیره گردید.',
                    'باشه',
                    5000,
                );
            },
            () => {
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    return (
        <>
            <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>فرم مشاوره دانش‌آموز</b>
                            </div>
                            <span className="students-consult-form-desc">لطفا برای دسترسی به بخش مشاوره، ابتدا فرم زیر را تکمیل فرمایید.</span>
                            {
                                questions.map((d, i) =>
                                    <div key={"JfXd" + i} className={"students-consult-form-item" + (d.error ? ' is-invalid':'')}>
                                        <p>{d.title}</p>
                                        {
                                            d.type === 'radio' || d.type === 'check' ?
                                                d.options.map((check, j) =>
                                                    <button
                                                        className={"techaran-checkbox" + (check === d.answer ? ' active' : '')}
                                                        key={"HcXs1" + j} onClick={() => setQuestions(v => {
                                                        let x = [...v];
                                                        x[i].error = false;
                                                        x[i].answer = check;
                                                        return x;
                                                    })}>
                                                        <i><CheckIcon/></i>
                                                        <span>{check}</span>
                                                    </button>
                                                ) :
                                                <input type="text"
                                                       className={"form-control" + (d.error ? ' is-invalid' : '')}
                                                       value={d.answer}
                                                       onChange={e => {
                                                           const t = e.currentTarget.value;
                                                           setQuestions(v => {
                                                               let x = [...v];
                                                               x[i].answer = t;
                                                               x[i].error = false;
                                                               return x;
                                                           })
                                                       }}
                                                />
                                        }
                                    </div>
                                )
                            }
                            <div className="d-flex justify-content-end align-items-center" style={{marginTop: 20}}>
                                <button className="btn-pay" onClick={saveForm}>
                                    <b>ذخیره فرم</b>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};